import React from "react";

import { Box } from "@mui/material";

const MainHeader = ({ children }) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				gap: 2,
				flexWrap: "wrap",
				flexShrink: 0,
				pb: 1,
			}}
		>
			{children}
		</Box>
	);
};

export default MainHeader;
